module.exports = {
      id: "palo-english-usage",
      viewBox: "0 0 230 78",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#palo-english",
      toString: function () {
        return this.url;
      }
    }